import { translate } from '../../../../common/helpers/translate.helper';
import { ComboBoxOption } from '../../../ComboBox/ComboBox';

export function getFilterValueLabel(options?: (ComboBoxOption | undefined)[]): string | undefined {
    const definedOptions = options?.filter((it): it is ComboBoxOption => it !== undefined);

    if (!definedOptions || definedOptions.length === 0) {
        return undefined;
    }

    const labels = definedOptions.map((value) => value.label);

    if (labels.length < 2) {
        return labels.join(', ');
    }

    const translatedMoreItems = translate('global.filterMultiSelect.xMoreItems', {
        count: (labels.length - 1).toString(),
    });

    return `${labels[labels.length - 1]} ${translatedMoreItems}`;
}
